// src/hooks/useWorkAccountability.ts
//
// Single gate for the Work Accountability UX (PR-E). Everything is hidden unless
// the feature flag is on — fail-closed (unknown ⇒ false), so the app behaves
// byte-for-byte as before when disabled. Also exposes the owner/admin manage
// check used across the WA surfaces.

import { useFeatureFlag } from './useFeatureFlag';
import { useCurrentCrmRole } from './useCurrentCrmRole';

export const WORK_ACCOUNTABILITY_FLAG = 'crm.work_accountability' as const;

/** True iff the Work Accountability UX should be visible at all. Fail-closed. */
export function useWorkAccountabilityEnabled(): boolean {
  return useFeatureFlag(WORK_ACCOUNTABILITY_FLAG);
}

/** True iff the current user may manage policies / assign person rules (owner/admin). */
export function useCanManageAccountability(): boolean {
  const crmRole = useCurrentCrmRole();
  return crmRole.key === 'owner' || crmRole.key === 'administrator';
}
